import React, { useState, useRef, useCallback, useEffect } from 'react';
import t from '~t';

import {
  Modal,
  ModalHeader as Header,
  ModalContent as Content,
} from '~ui';
import { Preloader } from '~ui'

export default function PickerSourceBaseProgress({
  items = [],
  getName,
  process, //async
  onDone,
  onCancel,
}) {
  const [done, setDone] = useState([]);
  const [failed, setFailed] = useState([]);
  const [uploading, setUploading] = useState(false);

  const latest = useRef();
  latest.current = { items, getName, process, onDone, onCancel };

  const cancel = useCallback(() => {
    setDone([]);
    setFailed([]);
    setUploading(false);
    latest.current.onCancel();
  }, []);

  const upload = useCallback(async () => {
    const { items, process, getName } = latest.current;
    if (!items.length) return;

    setDone([]);
    setFailed([]);
    setUploading(true);

    let failedList = [];
    for (const i in items) {
      const item = items[i];
      try {
        await process(item);
        const name = getName(item);
        setDone((done) => [...done, name]);
      } catch (e) {
        //server codes (pro_required, …) ship as `error` — resolve the
        //localized string before falling back to the raw message
        const fail = {
          name: getName(item),
          message:
            e?.error && t.has('server' + e.error)
              ? t.s('server' + e.error)
              : e.message,
        };
        failedList = [...failedList, fail];
        setFailed((failed) => [...failed, fail]);
      }
    }

    if (!failedList.length) {
      if (typeof latest.current.onDone == 'function')
        latest.current.onDone();

      cancel();
    } else setUploading(false);
  }, [cancel]);

  useEffect(() => {
    upload();
  }, [items, upload]);

  if (!uploading && !failed.length) return null;

  return (
    <Modal closable={!!failed.length} onClose={cancel}>
      <Header title={t.s('uploadProgress')} data-no-shadow>
        {uploading ? <Preloader /> : null}
      </Header>

      <Content data-indent>
        <div className='font-semibold text-[length:var(--title-font-size)]'>
          {t.format('uploadProgressCount', done.length, items.length)}
        </div>

        {failed.map(({ name, message }) => (
          <div
            key={name}
            className='mt-[var(--padding-small)] text-[color:var(--danger-color)]'
          >
            <b>{name}</b> &mdash; {message || t.s('fileUploadUnable')}
          </div>
        ))}
      </Content>
    </Modal>
  );
}
